/* eslint-disable no-unused-vars */
enum EStatus {
  SUCESSO,
  PROCESSANDO,
  ERRO,
  BLOQUEADA,
  PENDENTE,
  ALERTA
}

export default EStatus;
